import { Type } from '@angular/core';

export class AddComponent {
    constructor(public component: Type<any>, public content: any) {}
}

export interface QuestionComponent {
    content: any;
}
